export default [
  {
    id: 4,
    title: 'آذربایجان شرقی',
    slug: 'East Azarbaijan',
  },
  {
    id: 5,
    title: 'آذربایجان غربی',
    slug: 'Western Azerbaijan',
  },
  {
    id: 25,
    title: 'اردبیل',
    slug: 'Ardabil',
  },
  {
    id: 11,
    title: 'اصفهان',
    slug: 'Esfahan',
  },
  {
    id: 31,
    title: 'البرز',
    slug: 'Alborz',
  },
  {
    id: 17,
    title: 'ایلام',
    slug: 'Ilam',
  },
  {
    id: 19,
    title: 'بوشهر',
    slug: 'Bushehr',
  },
  {
    id: 24,
    title: 'تهران',
    slug: 'Tehran',
  },
  {
    id: 15,
    title: 'چهارمحال و بختیاری',
    slug: 'Chaharmahal and Bakhtiari',
  },
  {
    id: 30,
    title: 'خراسان جنوبی',
    slug: 'South Khorasan',
  },
  {
    id: 10,
    title: 'خراسان رضوی',
    slug: 'Khorasan Razavi',
  },
  {
    id: 29,
    title: 'خراسان شمالی',
    slug: 'North Khorasan',
  },
  {
    id: 7,
    title: 'خوزستان',
    slug: 'Khuzestan',
  },
  {
    id: 20,
    title: 'زنجان',
    slug: 'Zanjan',
  },
  {
    id: 21,
    title: 'سمنان',
    slug: 'Semnan',
  },
  {
    id: 12,
    title: 'سیستان و بلوچستان',
    slug: 'Sistan and Baluchistan',
  },
  {
    id: 8,
    title: 'فارس',
    slug: 'Fars',
  },
  {
    id: 27,
    title: 'قزوین',
    slug: 'Qazvin',
  },
  {
    id: 26,
    title: 'قم',
    slug: 'Qom',
  },
  {
    id: 13,
    title: 'كردستان',
    slug: 'Kurdistan',
  },
  {
    id: 9,
    title: 'كرمان',
    slug: 'Kerman',
  },
  {
    id: 6,
    title: 'کرمانشاه',
    slug: 'Kermanshah',
  },
  {
    id: 18,
    title: 'كهگیلویه و بویراحمد',
    slug: 'Kohgiloyeh and Boyerahmad',
  },
  {
    id: 28,
    title: 'گلستان',
    slug: 'Golestan',
  },
  {
    id: 2,
    title: 'گیلان',
    slug: 'Gilan',
  },
  {
    id: 16,
    title: 'لرستان',
    slug: 'Lorestan',
  },
  {
    id: 3,
    title: 'مازندران',
    slug: 'Mazandaran',
  },
  {
    id: 1,
    title: 'مرکزی',
    slug: 'Markazi',
  },
  {
    id: 23,
    title: 'هرمزگان',
    slug: 'Hormozgan',
  },
  {
    id: 14,
    title: 'همدان',
    slug: 'Hamedan',
  },
  {
    id: 22,
    title: 'یزد',
    slug: 'Yazd',
  },
];
